import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import { Input } from './Input';
import { Button } from '../../components/Shared/Button';
import { GoogleIcon } from '../../components/Shared/Icons';
import LoadingPage from '../LoadingPage';

import { signIn } from '../../api/users/signIn';
import { validationSchema } from './validations';

import logoImgSrc from "./logo.png";
import './index.css';

function RememberMe({
  onRememberMe = () => { },
}) {
  return (
    <div className="RememberMeContainer">
      {/* TODO: Implement Remember me */}
      <div onClick={onRememberMe} className="RememberMe"></div>
      <div className="ForgotPassword">
        <span onClick={() => {
          // navigate("/passwordReset")
        }}>
          Forgot Password?
        </span>
      </div>
    </div>
  )
}

function SignIn() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [_, setEmail] = useState();
  const [__, setAlert] = useState({});

  async function onSubmit({ email, password }) {
    try {
      setLoading(true);
      setAlert({});
      const res = await signIn(email, password);
      if (res.data && res.data.teacher) {
        navigate('/teacher/dashboard');
        localStorage.setItem('teacher', 0);
      } else {
        navigate('/employee/dashboard');
        localStorage.setItem('teacher', 1);
      }

      localStorage.setItem('studentEnrolledLibraryId', res.data.student_library_id);
    } catch (error) {
      setAlert({
        code: error.code,
        message: error.message,
      });
      localStorage.setItem('teacher', null);
      localStorage.setItem('studentEnrolledLibraryId', null);
    } finally {
      setLoading(false);
      setEmail(email);
    }
  }

  const initialValues = {
    email: '',
    password: '',
  }
  const formik = useFormik({
    onSubmit: onSubmit,
    initialValues: initialValues,
    validationSchema: validationSchema,
  });

  if (loading) return <LoadingPage />

  function renderBackgroundVector() {
    return (
      <svg width="400" height="593" viewBox="0 0 400 593" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M101.92 71.9174C32.3448 42.6009 -38.405 216.249 -38.405 216.249L-76 515.223C-76 515.223 -41.5225 565.927 -9.99023 582.48C58.4704 618.418 101.653 531.649 177.11 527.005C277.858 520.804 329.546 606.52 429.346 589.843C478.526 581.625 550 544.187 550 544.187C550 544.187 454.544 384.726 376.014 411.638C333.801 426.103 335.356 489.242 291.644 496.077C236.319 504.728 232.788 404.91 177.11 399.855C117.484 394.442 102.753 502.257 44.6536 486.258C-11.4515 470.808 -43.5692 413.413 -38.405 348.799C-32.1562 270.614 40.7365 214.56 108.478 233.923C140.193 242.988 144.759 282.373 177.11 287.924C238.313 298.427 248.735 96.5788 282.464 154.884C297.564 180.987 277.343 207.258 291.644 233.923C322.208 290.91 407.21 181.198 443.335 233.923C471.132 274.492 404.956 337.383 443.335 365C482.941 393.499 550 302.161 550 302.161V71.9174C550 71.9174 466.752 153.702 416.232 127.392C373.749 105.268 398.282 37.6456 358.965 9.07898C283.231 -45.9472 248.796 199.765 167.93 154.884C133.245 135.633 138.145 87.1809 101.92 71.9174Z" stroke="white" stroke-opacity="0.25" />
      </svg>
    )
  }

  return (
    <div className="SignInContainer">
      <div className="SignInLogoContainer">
        <div className="SignInLogo">
          <div className='LogoContainer'>
            <img width="156" height="41" src={logoImgSrc} />
          </div>
          <div className='SignInBackgroundVector'>{renderBackgroundVector()}</div>
          <div className='SignInCallToAction'>
            Knowledge is power. Let's get started.
          </div>
          <div className='SubSignInCallToAction'>
            Please continue with google or enter your details
          </div>
        </div>
      </div>

      <div className="SignInFormContainer">
        <div className="SignInFormHeader">
          Generational Master Classes
        </div>
        <div className="SignInFormSubHeader">
          Please continue with google or enter your details
        </div>
        <div className="SignInWithGoogle">
          <Button
            block
            text='Continue with Google'
            color='white'
            renderIcon={() => <GoogleIcon />}
          />
        </div>
        <div className="SignInFormDivider">
          <div><span>OR</span></div>
          <div className="SignInFormDividerLine"></div>
        </div>
        <div className="SignInForm">
          <form onSubmit={formik.handleSubmit}>
            <Input
              id='email'
              type='email'
              name='email'
              placeholder="Enter your email"
              {...formik.getFieldProps('email')}
              error={
                formik.touched.email && formik.errors.email
              }
            />
            <Input
              id='password'
              type='password'
              name='password'
              placeholder="Enter your password"
              error={
                formik.touched.password && formik.errors.password
              }
              {...formik.getFieldProps('password')}
            />
            <RememberMe />
            <div className="SignInFormSubmit">
              <Button
                block
                text="Sign in"
                type="submit"
              />
            </div>
            <div className="DontHaveAnAccout">
              <span>Don't have an account?</span>
              <span onClick={() => navigate("/signUp")}>Sign up</span>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SignIn;
